import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, Filter, ChevronDown, MoreHorizontal, Edit, Link, DollarSign, Eye, Plus } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
import { ZipCodeFilter } from '../components/ZipCodeFilter';
import { SupplierFilter } from '../components/SupplierFilter';
import { ExportButton } from '../components/ExportButton';
import { EditProductModal } from '../components/EditProductModal';
import { MarketplacePricingModal } from '../components/MarketplacePricingModal';
import { CompetitorLinksModal } from '../components/CompetitorLinksModal';
import { CreateProductModal } from '../components/CreateProductModal';
interface ProductsProps {
  onProductClick: (id: number) => void;
}
export function Products({
  onProductClick
}: ProductsProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeModal, setActiveModal] = useState<'edit' | 'marketplace' | 'links' | 'create' | null>(null);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const products = [{
    id: 1,
    sku: 'SAM-TV55-4K',
    name: 'Smart TV Samsung 55" 4K',
    category: 'Eletrônicos',
    supplier: 'Samsung',
    championSupplier: 'Samsung',
    price: 2899.0,
    minPrice: 2600.0,
    marketAvg: 2750.0,
    diff: 5.4,
    status: 'acima' as const
  }, {
    id: 2,
    sku: 'APL-IP14-128',
    name: 'iPhone 14 128GB',
    category: 'Eletrônicos',
    supplier: 'Apple',
    championSupplier: 'Amazon',
    price: 4199.0,
    minPrice: 4000.0,
    marketAvg: 4250.0,
    diff: -1.2,
    status: 'abaixo' as const
  }, {
    id: 3,
    sku: 'BRA-REF-FF',
    name: 'Geladeira Brastemp Frost Free',
    category: 'Eletrodomésticos',
    supplier: 'Brastemp',
    championSupplier: 'Magalu',
    price: 3499.0,
    minPrice: 3200.0,
    marketAvg: 3499.0,
    diff: 0.0,
    status: 'dentro' as const
  }, {
    id: 4,
    sku: 'DEL-INS-15',
    name: 'Notebook Dell Inspiron 15',
    category: 'Informática',
    supplier: 'Dell',
    championSupplier: 'Kabum',
    price: 3899.0,
    minPrice: 3700.0,
    marketAvg: 4100.0,
    diff: -4.9,
    status: 'abaixo' as const
  }, {
    id: 5,
    sku: 'MON-AF-4L',
    name: 'Air Fryer Mondial 4L',
    category: 'Eletroportáteis',
    supplier: 'Mondial',
    championSupplier: 'Amazon',
    price: 399.0,
    minPrice: 350.0,
    marketAvg: 350.0,
    diff: 14.0,
    status: 'acima' as const
  }, {
    id: 6,
    sku: 'SON-PS5-DIG',
    name: 'Console PlayStation 5',
    category: 'Games',
    supplier: 'Sony',
    championSupplier: 'Sony',
    price: 3699.0,
    minPrice: 3500.0,
    marketAvg: 3699.0,
    diff: 0.0,
    status: 'dentro' as const
  }, {
    id: 7,
    sku: 'NES-ESS-MIN',
    name: 'Cafeteira Nespresso Essenza',
    category: 'Eletroportáteis',
    supplier: 'Nespresso',
    championSupplier: 'Fast Shop',
    price: 449.0,
    minPrice: 400.0,
    marketAvg: 480.0,
    diff: -6.5,
    status: 'abaixo' as const
  }, {
    id: 8,
    sku: 'LG-MON-29',
    name: 'Monitor LG Ultrawide 29"',
    category: 'Informática',
    supplier: 'LG',
    championSupplier: 'Kabum',
    price: 1299.0,
    minPrice: 1100.0,
    marketAvg: 1150.0,
    diff: 12.9,
    status: 'acima' as const
  }, {
    id: 9,
    sku: 'ELE-MIC-34',
    name: 'Micro-ondas Electrolux 34L',
    category: 'Eletrodomésticos',
    supplier: 'Electrolux',
    championSupplier: 'Magalu',
    price: 699.0,
    minPrice: 650.0,
    marketAvg: 720.0,
    diff: -2.9,
    status: 'abaixo' as const
  }, {
    id: 10,
    sku: 'JBL-SB-CIN',
    name: 'Soundbar JBL Cinema',
    category: 'Áudio',
    supplier: 'JBL',
    championSupplier: 'Amazon',
    price: 999.0,
    minPrice: 900.0,
    marketAvg: 999.0,
    diff: 0.0,
    status: 'dentro' as const
  }];
  const filteredProducts = products.filter(p => p.name.toLowerCase().includes(searchTerm.toLowerCase()) || p.category.toLowerCase().includes(searchTerm.toLowerCase()) || p.sku.toLowerCase().includes(searchTerm.toLowerCase()));
  const handleAction = (action: 'edit' | 'marketplace' | 'links', product: any, e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedProduct(product);
    setActiveModal(action);
  };
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} className="space-y-6" data-id="element-622">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-623">
        <div data-id="element-624">
          <h1 className="text-2xl font-bold text-navy-900" data-id="element-625">
            Gerenciamento de Produtos
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-626">
            Monitore e ajuste preços de {products.length} produtos ativos
          </p>
        </div>

        <div className="flex flex-wrap gap-3 w-full md:w-auto items-center" data-id="element-627">
          <ZipCodeFilter data-id="element-628" />
          <SupplierFilter data-id="element-629" />
          <ExportButton data-id="element-630" />
          <button onClick={() => setActiveModal('create')} className="flex items-center space-x-2 px-4 py-2 bg-navy-900 text-white rounded-lg text-sm font-medium hover:bg-navy-800 transition-colors shadow-sm" data-id="element-631">
            <Plus className="h-4 w-4" data-id="element-632" />
            <span data-id="element-633">Novo Produto</span>
          </button>
        </div>
      </div>

      <div className="flex flex-col md:flex-row gap-4 bg-white p-4 rounded-xl border border-slate-200 shadow-sm" data-id="element-634">
        <div className="relative flex-1" data-id="element-635">
          <input type="text" placeholder="Buscar por nome, SKU ou categoria..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-900 focus:border-transparent" data-id="element-636" />
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" data-id="element-637" />
        </div>
        <div className="flex gap-2" data-id="element-638">
          <button className="flex items-center px-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-100" data-id="element-639">
            <Filter className="h-4 w-4 mr-2" data-id="element-640" />
            Mais Filtros
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-641">
        <div className="overflow-x-auto" data-id="element-642">
          <table className="w-full text-left text-sm" data-id="element-643">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-644">
              <tr data-id="element-645">
                <th className="px-6 py-4 font-mono text-xs uppercase tracking-wider" data-id="element-646">
                  SKU
                </th>
                <th className="px-6 py-4 cursor-pointer hover:text-navy-900" data-id="element-647">
                  Produto <ChevronDown className="inline h-3 w-3 ml-1" data-id="element-648" />
                </th>
                <th className="px-6 py-4" data-id="element-649">Fornecedor Campeão</th>
                <th className="px-6 py-4 text-right" data-id="element-650">Seu Preço</th>
                <th className="px-6 py-4 text-right" data-id="element-651">Média Mercado</th>
                <th className="px-6 py-4 text-right" data-id="element-652">Diferença</th>
                <th className="px-6 py-4 text-right" data-id="element-653">Preço Mín.</th>
                <th className="px-6 py-4 text-center" data-id="element-654">Status</th>
                <th className="px-6 py-4 text-center" data-id="element-655">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-656">
              {filteredProducts.map((product, index) => <tr key={product.id} onClick={() => onProductClick(product.id)} className={`group cursor-pointer hover:bg-navy-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50/50'}`} data-id="element-657">
                  <td className="px-6 py-4 font-mono text-xs text-slate-500" data-id="element-658">
                    {product.sku}
                  </td>
                  <td className="px-6 py-4 font-medium text-navy-900 group-hover:text-navy-700" data-id="element-659">
                    {product.name}
                    <span className="block text-xs text-slate-400 font-normal mt-0.5" data-id="element-660">
                      {product.category}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-661">
                    {product.championSupplier}
                  </td>
                  <td className="px-6 py-4 text-right font-bold text-navy-900" data-id="element-662">
                    R${' '}
                    {product.price.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2
                })}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-500" data-id="element-663">
                    R${' '}
                    {product.marketAvg.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2
                })}
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-664">
                    <span className={`font-medium ${product.diff > 0 ? 'text-red-600' : product.diff < 0 ? 'text-emerald-600' : 'text-slate-400'}`} data-id="element-665">
                      {product.diff > 0 ? '+' : ''}
                      {product.diff}%
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right text-slate-400 text-xs" data-id="element-666">
                    R${' '}
                    {product.minPrice.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2
                })}
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-667">
                    <StatusBadge status={product.status} data-id="element-668" />
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-669">
                    <div className="flex items-center justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-670">
                      <button onClick={e => handleAction('edit', product, e)} className="p-1.5 hover:bg-white rounded-md text-slate-400 hover:text-navy-900 shadow-sm border border-transparent hover:border-slate-200 transition-all" title="Editar Produto" data-id="element-671">
                        <Edit className="h-4 w-4" data-id="element-672" />
                      </button>
                      <button onClick={e => handleAction('marketplace', product, e)} className="p-1.5 hover:bg-white rounded-md text-slate-400 hover:text-navy-900 shadow-sm border border-transparent hover:border-slate-200 transition-all" title="Preços por Marketplace" data-id="element-673">
                        <DollarSign className="h-4 w-4" data-id="element-674" />
                      </button>
                      <button onClick={e => handleAction('links', product, e)} className="p-1.5 hover:bg-white rounded-md text-slate-400 hover:text-navy-900 shadow-sm border border-transparent hover:border-slate-200 transition-all" title="Gerenciar Links" data-id="element-675">
                        <Link className="h-4 w-4" data-id="element-676" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="px-6 py-4 border-t border-slate-200 bg-slate-50 flex justify-between items-center text-sm text-slate-500" data-id="element-677">
          <span data-id="element-678">
            Mostrando {filteredProducts.length} de {products.length} produtos
          </span>
          <div className="flex gap-2" data-id="element-679">
            <button className="px-3 py-1 border border-slate-200 rounded bg-white disabled:opacity-50" disabled data-id="element-680">
              Anterior
            </button>
            <button className="px-3 py-1 border border-slate-200 rounded bg-white hover:bg-slate-50" data-id="element-681">
              Próxima
            </button>
          </div>
        </div>
      </div>

      {/* Modals */}
      <EditProductModal isOpen={activeModal === 'edit'} onClose={() => setActiveModal(null)} product={selectedProduct} onSave={data => console.log('Saved', data)} data-id="element-682" />

      <MarketplacePricingModal isOpen={activeModal === 'marketplace'} onClose={() => setActiveModal(null)} product={selectedProduct} data-id="element-683" />

      <CompetitorLinksModal isOpen={activeModal === 'links'} onClose={() => setActiveModal(null)} product={selectedProduct} data-id="element-684" />

      <CreateProductModal isOpen={activeModal === 'create'} onClose={() => setActiveModal(null)} onCreate={data => console.log('Created', data)} data-id="element-685" />
    </motion.div>;
}